import axios from 'axios';

const API = axios.create({
  baseURL: 'https://isnnetwork.onrender.com', // your backend base URL
});

export default API;
